/**
*
* Blocks
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from 'components/media/Icon/index.js';

const SIZE = 30;
const GUTTER = 4;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-right: -${GUTTER}px;
  width: ${(p) => ((p.cols * (SIZE + GUTTER)))}px;
  & > * {
    flex: 0 0 ${SIZE}px;
    height: ${SIZE}px;
    margin-bottom: ${GUTTER}px;
    margin-left: 0 !important;
    margin-right: ${GUTTER}px;
  }

`;

const ColorButton = styled.button`
  background-color: ${(p) => p.color};
  color: #fff;
  border-radius: 8px;
`;

function Blocks(props) {
  const { value, options, onChange } = props;
  const altOrder = [...options.slice(0, 5), ...options.slice(10, 12), ...options.slice(5, 10), ...options.slice(12, 14)];
  return (
    <Wrapper cols={options.length / 2}>
      {altOrder.map((o) => (
        <ColorButton key={o.value} type="button" color={o.value} title={o.label} onClick={() => onChange(o.value)}>
          {o.value === value && <Icon className="ss-checkmark" inline />}
        </ColorButton>
      ))}
    </Wrapper>
  );
}

Blocks.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Blocks;
